import * as React from "react";
import {Business, CurrentUser, UserCard} from "../../types/Types";
import {useState} from "react";
import DisplayListControl from "../list/DisplayListControl";
import {convertTimestamp} from "../../utils/Utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router";
import {useEffect} from "react";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db} from "../../firebase/FirebaseProvider";

interface Props {
  currentUser: CurrentUser | undefined,
  businessId: string | undefined,
  defaultDisplayList: boolean,
}

function CustomerCardList(props: Props) {
  const navigate = useNavigate();
  const [displayList, setDisplayList] = useState<boolean>(props.defaultDisplayList);
  const [cards, setCards] = useState<Array<UserCard>>([]);

  const hasExpired = (expiresAt: number) => {
    return false;
  };

  useEffect(() => {(async () => {
    if(!props.businessId) {
      return
    }
    let cards: UserCard[] = new Array<UserCard>();
    const cardsCollection = query(
        collection(db, 'cards'),
        where("business", "==", props.businessId),
        where("status", "==", "ACTIVE"),
        orderBy("userName", "asc"),
        limit(200),
    );
    const cardsSnapshot = await getDocs(cardsCollection);
    cardsSnapshot.forEach((doc) => {
      cards.push(doc.data() as UserCard);
    });
    setCards(cards);
  })();
  }, [props.businessId]);

  if(!props.currentUser) {
    return <></>
  }

  return (
    <div className={"mt-3"}>
       <div className={`list-title ${displayList ? "" : "mb-0"}`} onClick={() => setDisplayList(!displayList)}>
          <b>Customer Cards</b>
          <DisplayListControl displayList={displayList} count={cards.length} />
        </div>
        {cards && displayList && cards.map((card, index) => (
            <div className={`basic-box colour-secondary cursor-pointer ${index == cards.length-1 ? 'mb-0' : 'mb-2'} ${hasExpired(card.expiresAt.toMillis()) ? 'danger' : ''}`} onClick={() => navigate(`/card/${card.id}`)}>
              <div className={"d-inline-block"}>
                <div className={"me-2"}>
                  <div className={"d-inline-block me-2 font-weight-600"}>{card.userName}</div>
                  <div className={"font-sm tag grey"}>#{card.cardNumber}</div>
                </div>
                <div className={"d-inline-block me-2 font-sm1"}>Start: <span className={""}>{convertTimestamp(card.createdAt)}</span></div>
                <div className={"d-inline-block me-2 font-sm1"}>Exp: <span className={""}>{convertTimestamp(card.expiresAt)}</span></div>
              </div>
              <div className={"d-inline-block float-right tag grey font-md"}>{card.points} <FontAwesomeIcon icon={faStar} /></div>
            </div>
        ))}
      {(!cards || cards.length == 0) && <div className={"basic-box colour-secondary mb-0 mt-0 left-align"}>Nothing to display.</div>}
    </div>
  )
}

export default CustomerCardList;